<template>
  <div
    class="isp-task-bd tb"
    v-if="funcView.isp_task_list"
  >
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0;">
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.search"
            :placeholder="$t('dms_ispTask.ren_wu_ming_cheng')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter()"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <el-form-item :label="$t('dms_ispTask.qi_dong_shi_jian')">
          <custom-date-picker
            style="width: 100%"
            v-model="formSearch.operatorTime"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        height="100%"
        :data="tableList"
        :column="tableColumn"
        :index="true"
        @filter="filterChange"
        :slots="['checkDetail', 'taskName', 'taskStatus']"
        @sort="sortChange"
      >
        <template v-slot:taskName="scope">
          <div>
            <span
              v-if="funcView.isp_task_detail"
              class="cell-link"
              @click="onTaskDetailDrawer(scope.row)"
            >{{
              scope.row.taskName }}</span>
            <span v-else>{{ scope.row.taskName }}</span>
          </div>
        </template>
        <template v-slot:checkDetail="scope">
          <span
            v-if="funcView.isp_task_content"
            class="cell-link"
            @click="onTaskDetail(scope.row)"
          >{{ $t('Common.com_detail') }}</span>
        </template>
        <template v-slot:taskStatus="scope">
          <span class="task-status">{{ $t('dms_ispTask.dai_fa_bu') }} ({{ $t('dms_ispTask.zong') }}:{{ scope.row.taskTotalNum || 0 }}, {{ $t('dms_ispTask.dai_zhi_xing') }}:{{ scope.row.taskWaitNum || 0 }}, {{ $t('dms_ispTask.zhi_xing_zhong') }}:{{
            scope.row.taskExecutingNum || 0 }}, {{ $t('Common.com_success') }}:{{ scope.row.taskSuccessNum || 0 }}, {{ $t('Common.com_fail') }}:{{ scope.row.taskFailedNum || 0
  }}), {{ $t('dms_ispTask.yi_qu_xiao') }}:{{ scope.row.taskCancelNum || 0 }}</span>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <task-detail-dialog
      v-if="taskDetailVisible"
      @close="taskDetailVisible = false"
      :model="taskDetailModal"
    ></task-detail-dialog>
    <task-detail-drawer
      v-if="taskDetailDrawerVisible"
      @close="taskDetailDrawerVisible = false"
      :model="taskDetailDrawerModal"
    ></task-detail-drawer>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import taskDetailDialog from './children/task_detail_dialog';
import taskDetailDrawer from './children/task_detail_drawer';

export default {
  name: 'ispTask',
  mixins: [resetFormSearchMixins],
  components: {
    taskDetailDialog,
    taskDetailDrawer,
  },
  data() {
    return {
      tableCode: 'isp_task',
      dialogVisible: false,
      dialogModel: {},
      productId: '',
      productTotal: 0,

      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        // 最后使用时间
        operatorTime: [],
      },
      tableList: [],
      totalRows: null,
      link: null,
      taskDetailModal: {},
      taskDetailVisible: false,

      taskDetailDrawerModal: {},
      taskDetailDrawerVisible: false,
    };
  },
  activated: function () {
    this.getTableList();
  },
  computed: {},
  watch: {},
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);

    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getTableColumn();
  },
  methods: {
    onTaskDetail(row) {
      this.taskDetailModal = {
        data: row,
      };
      this.taskDetailVisible = true;
    },
    onTaskDetailDrawer(row) {
      this.taskDetailDrawerModal = {
        data: row,
        title: this.$t('dms_ispTask.SIMka_ji_huo'),
      };
      this.taskDetailDrawerVisible = true;
    },
    exportTable() {},
    getTableListReqData() {
      const ret = {
        ...this.formSearch,
      };

      const operatorTime = ret.operatorTime;
      if (operatorTime && operatorTime.length) {
        const taskStartStartTime = operatorTime[0];
        const taskStartEndTime = operatorTime[1];
        ret.taskStartStartTime = taskStartStartTime;
        ret.taskStartEndTime = taskStartEndTime;
      }

      delete ret.operatorTime;

      const lastActiveTime = ret.operatorTime;
      if (lastActiveTime && lastActiveTime.length) {
        const lastActiveTimeStartTime = lastActiveTime[0];
        const lastActiveTimeEndTime = lastActiveTime[1];
        ret.lastActiveTimeStartTime = lastActiveTimeStartTime;
        ret.lastActiveTimeEndTime = lastActiveTimeEndTime;
      }

      delete ret.operatorTime;

      return ret;
    },
    getMockList() {
      return [
        {
          simTaskId: 'simTaskId',
          taskName: 'taskName',
          taskType: '1',
          taskTotalNum: 20,
          // 任务来源      iot_cmd_task_source
          taskSource: '1',
          // 供应商账号
          supplierAccount: 'supplierAccount',
          // 供应商
          supplierName: 'supplierName',
          // 未执行
          taskWaitNum: 4,
          // 执行中
          taskExecutingNum: 4,
          // 执行成功
          taskSuccessNum: 4,
          // 执行失败
          taskFailedNum: 4,
          // 取消
          taskCancelNum: 4,
        },
      ];
    },
    // 获取列表
    getTableList: function () {
      const reqData = this.getTableListReqData();
      this.$getJSON(apis.simIspTaskPage, reqData).then((res) => {
        this.tableList = res.data.list;
        //   this.tableList = this.getMockList();
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.isp-task-bd {
  .task-status {
    word-break: break-all;
    white-space: normal;
  }
}
</style>
